import fetchWrapper from "../utils/fetchWrapper";

const sessionKey = "impersonateData";

const setEmployeeImpersonate = (employee) => {
  const json = JSON.stringify(employee);
  window.sessionStorage.setItem(sessionKey,
    json
  );
};
const clearEmployeeImersonate = () => {
  window.sessionStorage.removeItem(sessionKey);

}
const getImpersonatingEmployee = () => {
  const json = window.sessionStorage.getItem(sessionKey);
  return json ? JSON.parse(json) : null;
};

export class mockImpersonateService {
  constructor(mockValid) {
    this.valid = mockValid;
  }
}
class apiImpersonateService  {
  //calls the api to load an employee and returns a lighter object we can use to be mindful of when we are impersonating.
  checkEmployee = async (username) => {
    try {
      const path = `/api/employee/username/${username}`;
      const employee = await fetchWrapper({ url: path });
      const emplId = parseInt(employee?.id);
      const valid =
          employee != null && !isNaN(emplId) &&
          emplId > 0;
      if (!valid) {
        return null;
      }
      const { id, displayName, churchAccountId } = employee;
      const lightEmployee = { id, displayName, churchAccountId };
      setEmployeeImpersonate(lightEmployee);
      return lightEmployee;
    } catch (e) {
      return false;
    }
  };
}


export {setEmployeeImpersonate, clearEmployeeImersonate, getImpersonatingEmployee };
export default apiImpersonateService;
